import {questions} from './questions';

// SEO texts for the English-only pages without a language prefix (FAQ, policies)
export const FAQ_DESCRIPTION =
  'Answers to frequently asked questions about the Periodic Table app: the PRO version, full screen mode, languages and more.';

export const FAQ_TITLE = 'Periodic Table: FAQ — chernykh.tech';

export const faqAnswerTitle = (id) => {
  const question = questions.find((item) => item.id === Number(id));
  return question ? `${question.title} — chernykh.tech` : FAQ_TITLE;
};

export const faqAnswerDescription = (id) => {
  const question = questions.find((item) => item.id === Number(id));
  if (!question) return FAQ_DESCRIPTION;
  const text = `${question.title} ${question.shortDescription.replace(/\s+/g, ' ')}`;
  return text.length > 160 ? `${text.slice(0, 157).trim()}…` : text;
};

export const POLICIES = {
  '/privacy-policy': {
    lang: 'en',
    title: 'Privacy Policy — Periodic Table | chernykh.tech',
    description: 'Terms of Use and Privacy Policy of the Periodic Table app for Android.',
  },
  '/privacy-policy-ios': {
    lang: 'en',
    title: 'Privacy Policy — Periodic Table for iOS | chernykh.tech',
    description: 'Terms of Use and Privacy Policy of the Periodic Table app for iPhone and iPad.',
  },
  '/physics/privacy-policy/en': {
    lang: 'en',
    title: 'Privacy Policy — Physics: Formulas | chernykh.tech',
    description: 'Terms of Use and Privacy Policy of the Physics: Formulas app.',
  },
  '/physics/privacy-policy/ru': {
    lang: 'ru',
    title: 'Политика конфиденциальности — Физика: Формулы | chernykh.tech',
    description: 'Условия использования и политика конфиденциальности приложения «Физика: Формулы».',
  },
};
